import Vue from 'vue';
import Router from 'vue-router';
import { supportPanelRoutes } from '~/router/supportPanelRoutes';
import { OperatorModule } from '~/store/modules/operator';
import { eliotPanelRoutes } from './eliotRoutes';

const Index = () =>
    import(/* webpackChunkName: "index" */ '~/views/Index.vue');
const Logs = () =>
    import(/* webpackChunkName: "logs" */ '~/views/Logs.vue');
const SupportPanel = () =>
    import(/* webpackChunkName: "panel" */ '~/views/SupportPanel.vue');
const EliotPanel = () =>
    import(/* webpackChunkName: "eliot-panel" */ '~/views/EliotPanel.vue');
const OrderPanel = () =>
    import(/*webpackChunkName: "order-panel" */ '~/views/OrderPanel.vue');
const Documentation = () =>
    import(/*webpackChunkName: "documentation" */ '~/views/Documentation.vue');
const Denied = () =>
    import(/*webpackChunkName: "denied" */ '~/views/Denied.vue');
const WeatherExtract = () =>
    import(/*webpackChunkName: "weather-extract" */ '~/views/WeatherExtract.vue');
const RemoteFeatureFlags = () =>
    import(/*webpackChunkName: "remote-feature-flags" */ '~/views/RemoteFeatureFlags.vue');
Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: '',
    routes: [
        {
            path: '/support',
            name: 'index',
            component: Index,
            beforeEnter: (to: any, from: any, next: any) => {
                const keysRights = Object.keys(OperatorModule.adminRights);
                if (keysRights.length === 0) {
                    next('/support/denied');
                }
                next();
            },
        },
        {
            path : '/support/denied',
            name : 'denied',
            component : Denied,
            beforeEnter : (to : any, from : any, next : any) => {
                const keysRights = Object.keys(OperatorModule.adminRights);
                if (keysRights.length > 0) {
                    next('/support/');
                }
                next();
            },
        },
        {
            path: '/support/weather-extract',
            name: 'weather-extract',
            component: WeatherExtract,
            beforeEnter: (to: any, from: any, next: any) => {
                if (!OperatorModule.isAllowed('WeatherExtract')) {
                    next('/support/denied');
                }
                next();
            },
        },
        {
            path: '/support/remote-feature-flags',
            name: 'remote-feature-flags',
            component: RemoteFeatureFlags,
        },
        {
            path: '/support/logs',
            name: 'logs',
            component: Logs,
        },
        {
            path: '/support/user/:userIdentifier',
            name: 'user',
            component: SupportPanel,
            props: {
                default: true,
                isUserInfoShown: true,
            },
        },
        {
            path: '/support/eliotuser/:userIdentifier',
            name: 'eliotuser',
            component: EliotPanel,
            props: {
                default: true,
                isUserInfoShown: true,
            },
        },
        {
            path: '/support/order/:orderId',
            name: 'order',
            component: OrderPanel,
        },
        {
            path: '/support/documentation',
            name: 'documentation',
            component: Documentation,
        },
        {
            path: '/support/redirect',
            name: 'redirect',
            beforeEnter: (to: any, from: any, next: any) => {
                try {
                    const redirectUrl = new URL(to.query.url.toString());
                    if (redirectUrl.hostname.includes('netatmo.com')) {
                        window.location.href = redirectUrl.href;
                    }
                    // else {
                    //   ErrorsModule.error(null)
                    //   next()
                    // }
                } catch (err) {
                    next(err);
                }
            },
        },
        ...supportPanelRoutes,
        ...eliotPanelRoutes,
        ...[{
            path: '/support*',
            redirect: { name: 'index' },
        }],
    ],
});
export default router;
